<template>
  <div class="login-page">
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AuthLayout'
});
</script>

<style lang="scss" scoped></style>
